import { IBayPattern, ITierPattern } from "../types/IPositionPatterns";

import { BayLevelEnum } from "open-vessel-definition";
import { BaySizesAndCgs } from "./BaySizesAndCgs";
import { pad2 } from "@tedivo/tedivo-pure-helpers";

export function calculateBottomBasesByBay({
  blps,
  missingBottomBases,
  containerHeightInMm,
}: {
  blps: BaySizesAndCgs[];
  missingBottomBases: Record<ITierPattern, number>;
  /** Height, in mm, assumed for each tier when the deck height has to be estimated */
  containerHeightInMm?: number;
}) {
  const aboveBottomBases: Record<IBayPattern, number> = {};
  const belowBottomBases: Record<IBayPattern, number> = {};

  // 1. Calculate bottom bases for each bay in the above deck
  blps
    .filter((bl) => bl.level === BayLevelEnum.ABOVE)
    .forEach((blp) => {
      const bottomBase = blp.getDeckBottomBase();

      aboveBottomBases[blp.isoBay] = bottomBase ?? missingBottomBases[pad2(blp.minTier)];
    });

  // 2. Calculate top of containers for each bay below the deck
  blps
    .filter((bl) => bl.level === BayLevelEnum.BELOW)
    .forEach((blp) => {
      // If the above deck has not been calculated, calculate it using bottom containers
      if (aboveBottomBases[blp.isoBay] === undefined) {
        const maxHeightFromBottomBase =
          blp.getDeckMaxTheoreticalAbsoluteHeight(containerHeightInMm);

        if (maxHeightFromBottomBase !== undefined) {
          aboveBottomBases[blp.isoBay] = maxHeightFromBottomBase;
        }
      }

      // Calculate the bottom base for the below deck
      const bottomBase = blp.getDeckBottomBase();

      belowBottomBases[blp.isoBay] = bottomBase ?? missingBottomBases[pad2(blp.minTier)];
    });

  return { aboveBottomBases, belowBottomBases };
}
